import { lazy } from '@/service/lazy'

export default [{
  name: 'Tabela Comissões',
  path: 'comissao',
  id: 'comissao',
  icon: 'fa fa-file-text-o',
  props: true,
  component: lazy('app/default/gerenciador/comissao/index'),
  meta: { requireAuth: true, rules: ['gerenciar_tabela_comissionamento', 'visualizar_tabela_comissionamento'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/comissao.js